const initialState = {
  data: undefined,
  errorMessage: null,
  isLoading: false,
  isFulfilled: false,
  isRejected: false,
};

export const GetCustomerByIDData = (state = initialState, action) => {
  switch (action.type) {
    case "GET_CUSTOMER_BY_ID_PENDING":
      return {
        ...state,
        isLoading: true,
        isRejected: false,
        isFulfilled: false,
      };
    case "GET_CUSTOMER_BY_ID_REJECTED":
      return {
        ...state,
        isLoading: false,
        isRejected: true,
        errorMessage: action.payload.response.data ?? null,
      };
    case "GET_CUSTOMER_BY_ID_FULFILLED":
      return {
        ...state,
        isLoading: false,
        isFulfilled: true,
        data: action.payload.response.data ?? null,
      };
    default:
      return state;
  }
};
